import React from 'react'
import './abouttoken.scss'

const AboutTaken = () => {
    return (
        <>
            <section className='token_bg'>
                <div className="custom-container token_main">
                    <img src="/assets/about/aboutcoins.png" alt="coins" />
                    <div className="token__right">
                        <h3 className='about_common_heading'>The <span style={{color: "#E6FF00"}}>$RAIN</span> Token</h3>
                        <p className='about_p'>
                            $RAIN is the native token of the Rain protocol, operating on the Arbitrum network. Holding the $RAIN token is required to access Trading Power and participate in the platform's prediction markets.
                            <span>
                                Token holders exercise their influence on the protocol’s development through the Rain DAO, the decentralized autonomous organization responsible for all governance decisions.
                            </span>

                            <span>
                                The protocol rewards key contributors—market creators, liquidity providers, and resolvers—directly in $RAIN tokens. This system aligns incentives and encourages active participation in the ecosystem.
                            </span>
                            <span>
                                A deflationary buyback and burn mechanism is also a core feature. From every market's trading volume, 2.5% is used to buy back and burn $RAIN tokens, directly linking the token's scarcity to platform activity.
                            </span>
                        </p>
                    </div>

                </div>
            </section>

        </>
    )
}

export default AboutTaken